import React, { useEffect, useState } from 'react';
import { Link as Anchor } from "react-router-dom";
import './PedidosMain.css';
import baseURL from '../../url';
import moneda from '../../moneda';
export default function PedidosMain() {
    const [pedidos, setPedidos] = useState([]);

    useEffect(() => { cargarPedidos(); }, []);

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`)
            .then(r => r.json())
            .then(d => setPedidos(d.pedidos?.reverse().slice(0, 5) || []))
            .catch(e => console.error('Error al cargar pedidos:', e));
    };

    const statusClass = (estado) => {
        const map = {
            'Pendiente': 'status-pending',
            'Preparacion': 'status-preparation',
            'Rechazado': 'status-rejected',
            'Entregado': 'status-delivered',
        };
        return map[estado] || 'status-default';
    };

    return (
        <div className='table-containerProductos'>
            <div className='deFlexMore'>
                <h3>Últimos pedidos</h3>
                <Anchor to={`/dashboard/pedidos`}>Ver más</Anchor>
            </div>
            <table className='pedidos-table'>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Estado</th>
                        <th>Cliente</th>
                        <th>Teléfono</th>
                        <th>Entrega</th>
                        <th>Pago</th>
                        <th>Total</th>
                        <th>Fecha</th>
                    </tr>
                </thead>
                <tbody>
                    {pedidos.map(item => (
                        <tr key={item.idPedido}>
                            <td style={{ fontWeight: 600, color: 'var(--text-color)' }}>{item.idPedido}</td>
                            <td><span className={`status-badge ${statusClass(item.estado)}`}>{item.estado}</span></td>
                            <td>{item.nombre}</td>
                            <td>{item.telefono}</td>
                            <td>{item.entrega}</td>
                            <td>{item.pago}</td>
                            <td style={{ fontWeight: 600, color: 'var(--success)' }}>{moneda} {item.total}</td>
                            <td style={{ color: 'var(--text-color2)', fontSize: '0.78rem' }}>
                                {new Date(item?.createdAt)?.toLocaleString('es-ES', {
                                    day: '2-digit', month: '2-digit', year: 'numeric',
                                    hour: '2-digit', minute: '2-digit'
                                })}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
